import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'

import pic11 from '../assets/images/pic11.jpg'

const Bread = (props) => (
    <Layout>
        <Helmet>
            <title>Bread</title>
            <meta name="description" content="Baguettes" />
            <html lang="en"/>
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>Bread</h1>
                    </header>
                    <div className="grid-wrapper">
                        <span className="image fit col-6"><img src={pic11} alt="Baguettes" /></span>
                        <p className="col-6">Bread is food made of flour, water, and yeast mixed together and baked.</p>
                    </div>
                </div>
            </section>
        </div>

    </Layout>
)

export default Bread